import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-798e00a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-pages" }
const _hoisted_2 = { class: "sub-account-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "shop-name" }
const _hoisted_5 = { class: "select-icon" }
const _hoisted_6 = ["src"]

import { ref, getCurrentInstance } from "vue";
import { SubAccountListItem } from "@/views/Login/_interface";
import { SELECTED_BADGE_IMG } from "@/views/Login/_static";
import { postLoginSonAccountApi } from "@/views/Login/_apis";

/** 导出事件 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["loginSonAccountSuccess"],
  setup(__props, { expose: __expose, emit: __emit }) {

const Emits = __emit;
/** 导入提示 */
const Message =
  getCurrentInstance()?.appContext.config.globalProperties.$message;

const icons = ref({
  badgeIcon: SELECTED_BADGE_IMG
});
/** 展示选择子账号登录弹窗 */
const showModal = ref<boolean>(false);
/** 登录加载状态 */
const confirmLoadingStatus = ref<boolean>(false);
/** 子账号列表 */
const sonAccountList = ref<SubAccountListItem[]>([]);
/** 选择的子账号 */
const selectSonAccount = ref<SubAccountListItem>({
  shopName: "",
  userId: 0
});

/** 确定选择的子账号 */
const handleSelectSonAccount = (item: SubAccountListItem) => {
  selectSonAccount.value = item;
};

/** 确定选择登录 */
const handleConfirmLoginSonAccount = async () => {
  if (selectSonAccount.value) {
    const res = await postLoginSonAccountApi({
      mainUserId: selectSonAccount.value.userId
    });
    if (res.status !== "200") return;
    Message.info("登录成功，跳转中...");
    localStorage.setItem("token", res.data.token);
    Emits("loginSonAccountSuccess");
    Message.destroy();
  } else {
    Message.warning("请选择子账号");
  }
};

/** 展示弹窗 */
const show = (data: SubAccountListItem[]) => {
  selectSonAccount.value = {
    shopName: "",
    userId: 0
  };
  sonAccountList.value = data;
  showModal.value = true;
};

/** 声明父组件调用的方法 */
__expose({
  show
});

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      open: showModal.value,
      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
      title: "选择登录子账号",
      width: 600,
      destroyOnClose: true,
      maskClosable: false,
      closable: false,
      keyboard: false,
      cancelButtonProps: {
        disabled: true
      },
      "confirm-loading": confirmLoadingStatus.value,
      onOk: handleConfirmLoginSonAccount
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sonAccountList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["sub-account-item", 
            selectSonAccount.value.userId === item.userId
              ? 'active-sub-account-item'
              : ''
          ]),
              key: item.userId,
              onClick: ($event: any) => (handleSelectSonAccount(item))
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.shopName), 1),
              _createElementVNode("div", _hoisted_5, [
                (selectSonAccount.value.userId === item.userId)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: icons.value.badgeIcon,
                      alt: ""
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_3))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["open", "confirm-loading"])
  ]))
}
}

})